import { useMemo } from 'react';

interface UseCountProperties<T> {
  items: T[];
  predicate: (item: T) => boolean;
}

const useCount = <T>({ items, predicate }: UseCountProperties<T>): number => {
  return useMemo(
    () =>
      items.filter((item) => {
        return predicate(item);
      }).length,
    [items, predicate],
  );
};

export default useCount;
